import { Profile } from '@/models/Profile';

const mergeProfileWithPreview = (
  saved: Profile,
  preview: Partial<Profile>,
): Profile => {
  if (Object.keys(preview).length === 0) return saved;

  return {
    ...saved,
    basic: preview.basic
      ? { ...saved.basic, ...preview.basic }
      : saved.basic,
    projectPreferences: preview.projectPreferences
      ? { ...saved.projectPreferences, ...preview.projectPreferences }
      : saved.projectPreferences,
    skills: preview.skills
      ? { ...saved.skills, ...preview.skills }
      : saved.skills,
    certificates: preview.certificates
      ? { ...saved.certificates, ...preview.certificates }
      : saved.certificates,
    educations: preview.educations
      ? { ...saved.educations, ...preview.educations }
      : saved.educations,
    references: preview.references
      ? { ...saved.references, ...preview.references }
      : saved.references,
    experiences: preview.experiences
      ? { ...(saved.experiences ?? {}), ...preview.experiences }
      : saved.experiences,
  };
};

export default mergeProfileWithPreview;
